import { useEffect, useState } from "react";

// Fetches the current competition once and exposes it only while it is
// genuinely open (status active AND within the server-authoritative window),
// so navigation/banners auto-hide before it opens and after it closes.
export function useActiveCompetition() {
  const [campaign, setCampaign] = useState(null);

  useEffect(() => {
    let alive = true;
    const base = process.env.REACT_APP_BACKEND_URL;
    fetch(`${base}/api/competition/active`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive || !d) return;
        const c = d.campaign;
        if (c && c.status === "active" && c.is_open) setCampaign(c);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const prizeAmount = campaign?.prize_value
    ? `R${Number(campaign.prize_value).toLocaleString("en-US")}`
    : "";

  return { campaign, isLive: !!campaign, prizeAmount };
}
